import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { money, shortDate } from "@/lib/invoice";

export default function QboBalance({ name }) {
  const [st, setSt] = useState(undefined);
  const [err, setErr] = useState(null);

  const load = () => {
    setSt(undefined); setErr(null);
    api.get("/qbo/customer-balance", { params: { name } }).then((r) => setSt(r.data))
      .catch((e) => { if (e.response?.status === 409) setSt(null); else { setErr(formatError(e)); setSt(null); } });
  };
  useEffect(() => { load(); }, [name]); // eslint-disable-line react-hooks/exhaustive-deps

  if (st === null && !err) return null;
  return (
    <div className="mt-4 border rounded-lg bg-card p-4" data-testid="qbo-balance">
      <div className="flex items-center gap-3">
        <div className="h-7 w-7 rounded bg-emerald-600 flex items-center justify-center text-[11px] font-bold text-white">qb</div>
        <p className="text-sm font-medium">QuickBooks balance</p>
        {st === undefined ? <Loader2 size={15} className="animate-spin text-primary" />
          : st && <p className={`font-mono font-bold ${st.balance > 0 ? "text-amber-400" : "text-emerald-400"}`} data-testid="qbo-balance-amount">{st.found ? money(st.balance) : "Not in QuickBooks yet"}</p>}
        <button onClick={load} className="ml-auto text-muted-foreground hover:text-primary transition-colors" aria-label="Refresh balance" data-testid="qbo-balance-refresh"><RefreshCw size={14} /></button>
      </div>
      {err && <p className="text-xs text-red-400 mt-2" data-testid="qbo-balance-error">{err}</p>}
      {st?.open_invoices?.length > 0 && (
        <table className="w-full text-sm mt-3" data-testid="qbo-open-invoices">
          <tbody>
            {st.open_invoices.map((i, k) => (
              <tr key={k} className="border-t">
                <td className="py-1.5 font-mono">{i.number || "—"}</td>
                <td className="py-1.5">{shortDate(i.date)}</td>
                <td className="py-1.5 text-right font-mono text-muted-foreground">{money(i.total)}</td>
                <td className="py-1.5 text-right font-mono text-amber-400">{money(i.balance)} open</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
